import { Badge, Form, Select, theme, Typography } from "antd";
import React from "react";

import { FacetProps } from "./types";

import { ResponsiveSelect } from "~/Atom/ResponsiveSelect";

export const Facet: React.FC<FacetProps> = ({
  facetData,
  label,
  handleChange,
  value,
  resetLabel,
  hideValueInLabel,
  returnValueKey,
}) => {
  const { token } = theme.useToken();

  return (
    <Form.Item label={<strong>{label}</strong>} colon={false}>
      <ResponsiveSelect
        onChange={handleChange}
        value={value}
        showSearch={true}
        mobileOptions={[{ label: resetLabel || "Show all", value: "" }].concat(
          facetData?.values.map((opt, idx) => ({
            label: `${opt.label} (${opt.value})`,
            value: opt[returnValueKey || "label"],
          })) || []
        )}
      >
        {resetLabel && (
          <Select.Option name="clear" value="">
            <Typography.Text italic={true} type="secondary">
              {resetLabel}
            </Typography.Text>
          </Select.Option>
        )}
        {facetData?.values.map((opt, idx) => (
          <Select.Option
            key={idx}
            name={opt.label}
            value={opt[returnValueKey || "label"]}
          >
            {hideValueInLabel ? (
              opt.label
            ) : (
              <React.Fragment>
                {opt.label}
                <Badge
                  size="small"
                  count={opt.value}
                  overflowCount={9999999}
                  style={{
                    marginLeft: "0.25rem",
                    top: "-2px",
                    padding: "0 0.25rem",
                    fontWeight: "bold",
                  }}
                  color={token.colorText}
                />
              </React.Fragment>
            )}
          </Select.Option>
        ))}
      </ResponsiveSelect>
    </Form.Item>
  );
};
